export default [
  {
    label: '@OnildoRocha',
    url: 'https://instagram.com/onildorocha',
  },
  {
    label: '@CozinhaRoccia',
    url: 'https://instagram.com/cozinharoccia',
  },
  {
    label: '@CasaRoccia',
    url: 'https://instagram.com/casaroccia',
  },
]
